document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('giveaway-greeting')) return;

  var params = new URLSearchParams(window.location.search);
  var name = params.get('name') || '';
  var scaRef = params.get('sca_ref') || '';
  var productHandle = params.get('product') || '';

  if (!scaRef) {
    document.getElementById('giveaway-no-params').style.display = 'block';
    document.getElementById('giveaway-page-content').style.display = 'none';
    return;
  }

  var fbMode = params.get('step') === 'fb';
  if (fbMode) document.querySelector('.giveaway-page').classList.add('giveaway-fbmode');

  if (name) {
    var subEl = document.getElementById('giveaway-subtitle');
    subEl.textContent = 'Hey ' + name;
    subEl.style.display = '';
  }

  // Tickets: ?giveaway=post,story,fb names the ones still open to them.
  // Unknown keys are ignored; no valid keys shows all three.
  var gridEl = document.getElementById('giveaway-grid');
  var gridBtns = Array.prototype.slice.call(gridEl.querySelectorAll('.giveaway-grid-btn'));
  var validKeys = gridBtns.map(function (b) { return b.getAttribute('data-giveaway'); });
  var wantKeys = (params.get('giveaway') || '').split(',')
    .map(function (k) { return k.trim().toLowerCase(); })
    .filter(function (k) { return validKeys.indexOf(k) !== -1; });
  if (!wantKeys.length) wantKeys = validKeys;
  gridBtns.forEach(function (b) {
    b.classList.toggle('open', wantKeys.indexOf(b.getAttribute('data-giveaway')) !== -1);
  });
  gridEl.style.gridTemplateColumns = 'repeat(' + wantKeys.length + ', 1fr)';
  var countText = wantKeys.length + (wantKeys.length === 1 ? ' ticket' : ' tickets');
  document.querySelectorAll('.giveaway-count').forEach(function (el) { el.textContent = countText; });

  gridBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-giveaway');
      gridBtns.forEach(function (o) { o.classList.toggle('active', o === b); });
      document.querySelectorAll('.giveaway-steps').forEach(function (st) {
        st.classList.toggle('active', st.id === 'giveaway-steps-' + key);
      });
    });
  });

  var pickerEl = document.getElementById('giveaway-picker');
  var thumbRow = pickerEl.querySelector('.giveaway-thumbs');
  var thumbEls = Array.prototype.slice.call(pickerEl.querySelectorAll('.giveaway-thumb'));
  var labelEl = document.getElementById('giveaway-piece-label');
  var heroTitle = document.getElementById('giveaway-hero-title');
  var heroImg = document.getElementById('giveaway-hero-img');

  var orderedHandle = '';
  var linkUrl = '';
  var captionText = '';
  var fbCaption = '';
  var fbCaptionEl = document.getElementById('giveaway-fb-caption');
  var fbLink = '';
  // No usable ?product= (affiliate with no order, or a handle we can't load):
  // brand link + brand caption for every method, no piece card and nothing
  // preselected. Never fall back to a default product (Keelan: the standing
  // desk for someone who never bought one reads as spam). Tapping a thumb in
  // the picker switches them to that piece.
  var brandShare = false;
  function enterBrandShare() {
    brandShare = true;
    linkUrl = 'https://keelanscott.co/' + encodeURIComponent(scaRef);
    captionText = 'Loving my furniture from @keelanscottco \u{1F525} My link gives you 5% off for the next 30 days: ' + linkUrl;
    fbLink = linkUrl;
    fbCaption = 'Loving my furniture from @Keelan Scott \u{1F525} My link gives you 5% off for the next 30 days.';
    fbCaptionEl.textContent = fbCaption;
    document.querySelector('.giveaway-page').classList.add('giveaway-brandshare');
  }
  var imageBlob = null;
  var imageFileName = 'keelan-scott.jpg';
  var selectionToken = 0;

  function findThumb(handle) {
    for (var i = 0; i < thumbEls.length; i++) {
      if (thumbEls[i].getAttribute('data-handle') === handle) return thumbEls[i];
    }
    return null;
  }

  // Selection -------------------------------------------------------------
  function selectProduct(handle, title, imageSrc, autoScroll) {
    var token = ++selectionToken;
    if (brandShare) {
      brandShare = false;
      document.querySelector('.giveaway-page').classList.remove('giveaway-brandshare');
    }
    linkUrl = 'https://keelanscott.co/products/' + encodeURIComponent(handle) +
      '?snowball=' + encodeURIComponent(scaRef);
    captionText = 'The ' + title + ' from @keelanscottco \u{1F525} My link gives you 5% off for the next 30 days: ' + linkUrl;
    fbLink = linkUrl;
    fbCaption = 'The ' + title + ' from @Keelan Scott \u{1F525} My link gives you 5% off for the next 30 days.';
    fbCaptionEl.textContent = fbCaption;

    labelEl.textContent = handle === orderedHandle ? 'You ordered' : 'Your pick';
    heroTitle.textContent = title;

    if (imageSrc) {
      heroImg.alt = title;
      heroImg.onload = function () { heroImg.style.display = ''; };
      heroImg.src = imageSrc.split('?')[0] + '?width=800';
    }

    var selected = null;
    thumbEls.forEach(function (t) {
      var on = t.getAttribute('data-handle') === handle;
      t.classList.toggle('selected', on);
      if (on) selected = t;
    });
    if (autoScroll && selected) {
      thumbRow.scrollLeft = selected.offsetLeft - (thumbRow.clientWidth - selected.clientWidth) / 2;
    }

    imageBlob = null;
    if (imageSrc) {
      fetch(imageSrc.split('?')[0] + '?width=1080')
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          if (token !== selectionToken) return;
          imageBlob = blob;
          imageFileName = 'keelan-scott' + (blob.type === 'image/png' ? '.png' : '.jpg');
        }).catch(function () {});
    }
  }

  function selectThumb(el, autoScroll) {
    selectProduct(el.getAttribute('data-handle'), el.getAttribute('data-title'), el.getAttribute('data-image'), autoScroll);
  }

  function wireThumb(el) {
    el.addEventListener('click', function () { selectThumb(el); });
  }
  thumbEls.forEach(wireThumb);

  // A product the picker does not carry (an add-on): fetch it, put it at the
  // front of the picker.
  function addFetchedProduct(product) {
    var images = (product.images || []).map(function (im) { return im.src; });
    var first = images[0] || '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'giveaway-thumb';
    btn.setAttribute('data-handle', product.handle);
    btn.setAttribute('data-title', product.title);
    btn.setAttribute('data-image', first);
    var thumbImg = document.createElement('img');
    thumbImg.src = first.split('?')[0] + '?width=200';
    thumbImg.alt = product.title;
    var label = document.createElement('span');
    label.textContent = product.title;
    btn.appendChild(thumbImg);
    btn.appendChild(label);
    thumbRow.insertBefore(btn, thumbRow.firstChild);
    thumbEls.unshift(btn);
    wireThumb(btn);
    return btn;
  }

  // Actions ---------------------------------------------------------------
  function isMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  function copyText(text, btn) {
    var temp = document.createElement('span');
    temp.textContent = text;
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    var range = document.createRange();
    range.selectNodeContents(temp);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    document.execCommand('copy');
    sel.removeAllRanges();
    document.body.removeChild(temp);
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.innerHTML = '&#10003; Copied!';
    setTimeout(function () { btn.textContent = label; }, 2000);
  }

  function nativeShare() {
    var shareData = { text: captionText, url: linkUrl };
    if (imageBlob) {
      var file = new File([imageBlob], imageFileName, { type: imageBlob.type });
      shareData.files = [file];
      if (navigator.canShare && !navigator.canShare(shareData)) delete shareData.files;
    }
    navigator.share(shareData).catch(function () {});
  }

  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      copyText(btn.getAttribute('data-copy') === 'link' ? linkUrl : captionText, btn);
    });
  });

  var mobile = isMobile() && navigator.share;
  document.querySelectorAll('.giveaway-steps [data-share="ig"]').forEach(function (btn) {
    btn.style.display = mobile ? '' : 'none';
    btn.addEventListener('click', nativeShare);
  });
  document.querySelectorAll('.giveaway-steps .giveaway-desktop-note, .giveaway-steps .giveaway-desktop-link').forEach(function (el) {
    el.style.display = mobile ? 'none' : '';
  });
  document.querySelectorAll('.giveaway-steps .giveaway-mobile-text').forEach(function (el) {
    el.style.display = mobile ? '' : 'none';
  });
  document.querySelectorAll('.giveaway-steps [data-share="fb"]').forEach(function (btn) {
    if (!mobile) btn.innerHTML = 'Continue to Facebook &rarr;';
    btn.addEventListener('click', function () {
      if (mobile) return nativeShare();
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(linkUrl), '_blank');
    });
  });

  // ?step=fb: copy the Facebook caption, then open the share target in the same
  // tap (both have to happen inside the click or the browser blocks them).
  // Mobile gets the native share sheet: with the FB app installed, a sharer.php
  // link opens the app to the feed and drops the link.
  var fbCopiedEl = document.getElementById('giveaway-fb-copied');
  if (mobile) fbCopiedEl.textContent = 'Caption copied! Pick Facebook, paste your caption, tag @Keelan Scott, and post publicly.';
  document.getElementById('giveaway-fb-go').addEventListener('click', function () {
    var btn = this;
    copyText(fbCaption, btn);
    fbCopiedEl.classList.add('show');
    if (mobile) {
      navigator.share({ url: fbLink }).catch(function () {});
      return;
    }
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(fbLink);
    var win = window.open(url, '_blank');
    if (!win) setTimeout(function () { window.location.href = url; }, 400);
  });

  // Initial piece ---------------------------------------------------------
  var matched = productHandle ? findThumb(productHandle) : null;
  if (matched) {
    orderedHandle = productHandle;
    selectThumb(matched, true);
  } else if (productHandle) {
    enterBrandShare();
    fetch('/products/' + encodeURIComponent(productHandle) + '.json')
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (data) {
        orderedHandle = data.product.handle;
        selectThumb(addFetchedProduct(data.product), true);
      })
      .catch(function () {});
  } else {
    enterBrandShare();
  }
});
